import { PermissionEnum } from 'src/app/models/auth0/permission.enum';
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  name: 'dev',
  production: true,
  api_base_url: 'https://dev.api.zenity.io',
  api_version: 'v1',
  api_beta_version: 'v1-beta',
  app_base_url: 'https://dev.app.zenity.io',
  auth0: {
    domain: 'zenity-dev-2.eu.auth0.com',
    clientId: 'N0FP11T8L5zHRlNOqvcoVso9lrEJeMml',
    audience: 'https://zenity-dev-2.eu.zenity.io/api/v3',
    scope: [
      'openid',
      'profile',
      'email',
      PermissionEnum.admin,
      PermissionEnum.operator,
      PermissionEnum.analyst,
      PermissionEnum.viewer,
    ],
  },
  dd: {
    enabled: true,
    clientToken: 'pube4a053801bcf1fbfd97d2ae34ce75482',
    env: 'dev',
    service: 'web-dev',
    forwardErrorsToLogs: false,
  },
  msal: {
    oauthClientId: 'b9629e5f-710d-4335-80d8-3b051e33a845',
  },
  zenityRedirectUriForOauthAuthorizationCodeFlow: 'https://dev.app.zenity.io/app/oauth-authorization-code-redirect',
  services: {
    'ai-edge-manager': {
      base_url: 'http://localhost:3001',
      api_version: 'api/v1',
      api_beta_version: 'api/v1-beta',
    },
  },
};
